import { createFileRoute } from '@tanstack/react-router';
import { ComingSoon } from '@/features/placeholder/ComingSoon.tsx';

// Placeholder until this area is ported — see docs/features/*-barn-ops.md.
export const Route = createFileRoute('/_app/barn-ops')({
  component: BarnOpsPage,
});

function BarnOpsPage() {
  return <ComingSoon slug="barn-ops" />;
}
